import React from 'react';

import './InvoiceDocument.css';


const InvoiceDocument = ({
  invoice,
  highlightField = '',
}) => {
  if (!invoice) {
    return null;
  }


  /* =====================================================
     FORMATARE BANI
  ===================================================== */

  const formatMoney = (
    value,
    currency = 'RON'
  ) => {
    const numericValue =
      Number(value) || 0;

    return `${numericValue.toLocaleString(
      'ro-RO',
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    )} ${currency}`;
  };


  /* =====================================================
     HIGHLIGHT CAMP
  ===================================================== */

  const getHighlightClass = (
    field
  ) => {
    return highlightField === field
      ? ' invoice-document-highlight'
      : '';
  };


  return (
    <div className="invoice-document-wrapper">

      <div className="invoice-document">


        {/* =================================================
            HEADER FACTURA
        ================================================= */}

        <div className="invoice-document-header">


          {/* SERIE + NUMAR */}

          <div>

            <span className="invoice-document-label">
              FACTURA
            </span>

            <h2>
              {invoice.series}
              {' '}
              {invoice.number}
            </h2>

          </div>


          {/* DATA + SCADENTA */}

          <div className="invoice-document-header-meta">

            <div
              className={
                getHighlightClass(
                  'date'
                )
              }
            >

              <span>
                Data emiterii
              </span>

              <strong>
                {invoice.date}
              </strong>

            </div>


            {invoice.dueDate && (
              <div
                className={
                  getHighlightClass(
                    'dueDate'
                  )
                }
              >

                <span>
                  Scadenta
                </span>

                <strong>
                  {invoice.dueDate}
                </strong>

              </div>
            )}

          </div>

        </div>


        {/* =================================================
            FURNIZOR + CLIENT
        ================================================= */}

        <div className="invoice-document-parties">


          {/* FURNIZOR */}

          <div
            className={`invoice-document-party${getHighlightClass(
              'supplier'
            )}`}
          >

            <span className="invoice-document-party-label">
              FURNIZOR
            </span>

            <h3>
              {invoice.supplier?.name}
            </h3>


            {invoice.supplier?.cui && (
              <p>
                CUI:
                {' '}
                <b>
                  {invoice.supplier.cui}
                </b>
              </p>
            )}


            {invoice.supplier?.regCom && (
              <p>
                Reg. Com.:
                {' '}
                {invoice.supplier.regCom}
              </p>
            )}


            {invoice.supplier?.address && (
              <p>
                {invoice.supplier.address}
              </p>
            )}


            {invoice.supplier?.iban && (
              <p>
                IBAN:
                {' '}
                {invoice.supplier.iban}
              </p>
            )}

          </div>


          {/* CLIENT */}

          <div
            className={`invoice-document-party${getHighlightClass(
              'customer'
            )}`}
          >

            <span className="invoice-document-party-label">
              CLIENT
            </span>

            <h3>
              {invoice.customer?.name}
            </h3>


            {invoice.customer?.cui && (
              <p>
                CUI:
                {' '}
                <b>
                  {invoice.customer.cui}
                </b>
              </p>
            )}


            {invoice.customer?.regCom && (
              <p>
                Reg. Com.:
                {' '}
                {invoice.customer.regCom}
              </p>
            )}


            {invoice.customer?.address && (
              <p>
                {invoice.customer.address}
              </p>
            )}

          </div>

        </div>


        {/* =================================================
            PRODUSE / SERVICII
        ================================================= */}

        <div className="invoice-document-table-wrapper">

          <table className="invoice-document-table">

            <thead>

              <tr>

                <th>#</th>

                <th>
                  Produs / serviciu
                </th>

                <th>
                  Cant.
                </th>

                <th>
                  U.M.
                </th>

                <th>
                  Pret unitar
                </th>

                <th>
                  TVA
                </th>

                <th>
                  Valoare
                </th>

              </tr>

            </thead>


            <tbody>

              {invoice.items?.map(
                (
                  item,
                  index
                ) => {
                  const quantity =
                    Number(
                      item.quantity || 0
                    );

                  const unitPrice =
                    Number(
                      item.unitPrice || 0
                    );

                  const lineValue =
                    quantity *
                    unitPrice;


                  return (
                    <tr
                      key={
                        item.id ||
                        index
                      }
                    >

                      <td>
                        {index + 1}
                      </td>


                      <td className="invoice-document-item-name">
                        {item.name}
                      </td>


                      <td>
                        {item.quantity}
                      </td>


                      <td>
                        {item.unit}
                      </td>


                      <td>
                        {formatMoney(
                          unitPrice,
                          invoice.currency
                        )}
                      </td>


                      <td>
                        {item.vatRate}%
                      </td>


                      <td>
                        {formatMoney(
                          lineValue,
                          invoice.currency
                        )}
                      </td>

                    </tr>
                  );
                }
              )}

            </tbody>

          </table>

        </div>


        {/* =================================================
            TOTALURI
        ================================================= */}

        <div className="invoice-document-summary">


          {/* SUBTOTAL */}

          <div
            className={`invoice-document-summary-row${getHighlightClass(
              'subtotal'
            )}`}
          >

            <span>
              Subtotal
            </span>

            <strong>
              {formatMoney(
                invoice.subtotal,
                invoice.currency
              )}
            </strong>

          </div>


          {/* TVA */}

          <div
            className={`invoice-document-summary-row${getHighlightClass(
              'vat'
            )}`}
          >

            <span>
              TVA
            </span>

            <strong>
              {formatMoney(
                invoice.vat,
                invoice.currency
              )}
            </strong>

          </div>


          {/* TOTAL */}

          <div
            className={`invoice-document-summary-row invoice-document-summary-total${getHighlightClass(
              'total'
            )}`}
          >

            <span>
              TOTAL DE PLATA
            </span>

            <strong>
              {formatMoney(
                invoice.total,
                invoice.currency
              )}
            </strong>

          </div>

        </div>


        {/* =================================================
            FOOTER
        ================================================= */}

        <div className="invoice-document-footer">

          <span>
            Document educational generat pentru exercitiul ContaLearn.
          </span>

        </div>

      </div>

    </div>
  );
};


export default InvoiceDocument;